// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ntfK","col":"styles_col__23X54"};